export const HEATMAP_COLORS = {
  panel: '#161616',
  long: '#1C76A2',
  short: '#D8483B',
  gold: '#C2A14E',
  /** Dashed ±1σ and ±2σ on the light field. */
  cone: '#64748b',
  /** Ridge along the positive gamma peak. */
  peak: '#17803d',
  /** Ridge along the negative gamma trough. */
  trough: '#1a1a1a',
  /** Smoothed zero contour. */
  zero: '#6b7280',
  sunrise: '#D8783B',
  muted: '#C7C2B8',
  grid: 'rgba(15,23,42,0.10)',
} as const;

/**
 * Light paper the field mixes from. A near-black mix hides the black trough.
 */
export const FIELD_BG: readonly [number, number, number] = [248, 250, 252];

export const FIELD_DOWNSAMPLE = 3;

export const HEATMAP_MARGIN = {
  top: 18,
  right: 52,
  bottom: 32,
  left: 52,
} as const;
